import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Module } from '@nestjs/common';
import { TypeOrmModule } from '@nestjs/typeorm';
import { CellsController } from './cells.controller';
import { Cell } from './cells.entity';
import { CellsService } from './cells.service';
import { CellAdapter } from './dto/cells.adapter';

@Module({
  imports: [
    TypeOrmModule.forFeature([Cell]),
  ],
  controllers: [CellsController],
  providers: [CellsService, CellAdapter,ApplicationExceptionHandler]
})
export class CellsModule {}
